export default (props, vars) =>
  !!vars?.['applicationcard2']?.['item'].current_step.action;
